var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 636,
    viewBox: "0 0 800 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500006V346.833L100 404.6V173.667L300 289.167L500 173.667V289.167L300 404.6V520.067L500 635.5L800 462.333V231.4L700 289.167V404.6L500 520.067L400 462.333L600 346.833V0.500006L300 173.667L0 0.500006ZM800 0.500006L700 58.1667V173.667L800 115.933V0.500006Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/mui.e964db69655ed80941c3b9564d1975d6.svg";
export { ForwardRef as ReactComponent };